import React, {useEffect, useState} from "react";
import "./Examination.scss";
import type {TabsProps} from "antd";
import {HistoryExamine, Tabs} from "components/common";
import ListExam from "./components/ListExam/ListExam";
import InforDetail from "./components/InforDetail/InforDetail";
import {useAppDispatch, useAppSelector} from "redux/hooks";
import {setButtonsHeader, setSiderKey} from "redux/reducer/common";
import {tabKeys} from "types/enums";
import ReportTV from "./components/Report/ReportTV";
import ReportRevenue from "./components/ReportRevenue/ReportRevenue";
import Chart from "./components/Chart/Chart";

const itemsInit: TabsProps["items"] = [
  {
    key: tabKeys.EXAMINATION.LIST_EXAM,
    label: `Danh sách khám bệnh`,
    children: <ListExam />,
  },
  {
    key: tabKeys.EXAMINATION.INFOR_DETAIL,
    label: `Chi tiết thông tin`,
    children: <InforDetail />,
  },
  {
    key: tabKeys.EXAMINATION.EXAM_HISTORY,
    label: `Lịch sử khám bệnh`,
    children: <HistoryExamine />,
  },
  {
    key: tabKeys.EXAMINATION.REPORT,
    label: `Báo cáo`,
    children: <ReportTV />,
  },
  {
    key: tabKeys.EXAMINATION.REPORT_REVENUE,
    label: `Báo cáo doanh thu theo bác sỹ`,
    children: <ReportRevenue />,
  },
  {
    key: tabKeys.EXAMINATION.CHART,
    label: `Biểu đồ`,
    children: <Chart />,
  },
];

const Examination = () => {
  document.title = "Khám bệnh ngoại trú";
  const [items, setItems] = useState<TabsProps["items"]>(itemsInit);
  const dispatch = useAppDispatch();
  const idPKNT = useAppSelector(state => state.examination.idPKNT);
  const activeTab = useAppSelector(state => state.common.activeTab);
  useEffect(() => {
    dispatch(setButtonsHeader([]));
    dispatch(setSiderKey("khamBenh"));
  }, []);
  useEffect(() => {
    itemsInit[1].disabled = idPKNT == null;
    itemsInit[2].disabled = idPKNT == null;
    setItems([...itemsInit]);
  }, [idPKNT]);
  return (
    <div className="examination page">
      <div className="main">
        <Tabs activeKey={activeTab} items={items} />
      </div>
    </div>
  );
};

export default Examination;
